var _rect, _rect2, _path, _mask, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.966797,
    width: 218.182,
    height: 220,
    rx: 15,
    fill: "#5D38E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.4904,
    y: 91.35,
    width: 88.8327,
    height: 62.898,
    rx: 4.125,
    stroke: "white",
    strokeWidth: 6.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.973 138.976L42.8418 138.976",
    stroke: "white",
    strokeWidth: 6.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_93_1929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.175 153.034H71.5486C71.2492 157.941 70.0437 162.741 68.0018 167.195C62.5369 167.562 58.2178 172.111 58.2178 177.669C58.2178 178.957 59.2622 180.002 60.5506 180.002H115.265C116.554 180.002 117.598 178.957 117.598 177.669C117.598 171.871 112.898 167.171 107.101 167.171H106.86C105.089 162.677 104.175 157.882 104.175 153.034Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5486 153.034V147.259C68.4958 147.259 65.9703 149.635 65.7844 152.682L71.5486 153.034ZM104.175 153.034H109.95C109.95 149.845 107.365 147.259 104.175 147.259V153.034ZM68.0018 167.195L68.3886 172.957C70.5022 172.815 72.3685 171.527 73.2513 169.602L68.0018 167.195ZM106.86 167.171L101.488 169.289C102.357 171.496 104.488 172.946 106.86 172.946V167.171ZM71.5486 158.809H104.175V147.259H71.5486V158.809ZM73.2513 169.602C75.5896 164.502 76.97 159.005 77.3129 153.386L65.7844 152.682C65.5283 156.877 64.4978 160.981 62.7522 164.788L73.2513 169.602ZM63.9928 177.669C63.9928 175.171 65.9357 173.122 68.3886 172.957L67.615 161.433C59.1382 162.002 52.4428 169.051 52.4428 177.669H63.9928ZM60.5506 174.227C62.4516 174.227 63.9928 175.768 63.9928 177.669H52.4428C52.4428 182.147 56.0728 185.777 60.5506 185.777V174.227ZM115.265 174.227H60.5506V185.777H115.265V174.227ZM111.823 177.669C111.823 175.768 113.364 174.227 115.265 174.227V185.777C119.743 185.777 123.373 182.147 123.373 177.669H111.823ZM107.101 172.946C109.709 172.946 111.823 175.061 111.823 177.669H123.373C123.373 168.682 116.088 161.396 107.101 161.396V172.946ZM106.86 172.946H107.101V161.396H106.86V172.946ZM98.4002 153.034C98.4002 158.608 99.4513 164.122 101.488 169.289L112.233 165.054C110.727 161.233 109.95 157.156 109.95 153.034H98.4002Z",
    fill: "white",
    mask: "url(#path-4-inside-1_93_1929)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.791 52.1548C128.772 51.8003 128.735 51.4645 128.735 51.11C128.735 42.3403 135.786 35.25 144.464 35.25C149.979 35.25 154.808 38.1048 157.621 42.4336C158.972 41.5193 160.6 40.9782 162.377 40.9782C167.095 40.9782 170.944 44.8406 170.944 49.6173C170.944 50.5315 170.796 51.4085 170.537 52.2481C170.667 52.2481 170.815 52.2295 170.944 52.2295C177.18 52.2295 182.25 57.342 182.25 63.63C182.25 69.918 177.365 74.8439 171.259 75.0118H131.603C125.386 74.8439 120.371 69.6941 120.371 63.3874C120.371 58.051 123.924 53.5729 128.772 52.1922L128.791 52.1548Z",
    stroke: "white",
    strokeWidth: 6.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2815 77.3252C70.1906 69.0752 74.0633 52.5752 98.2815 52.5752",
    stroke: "white",
    strokeWidth: 6.6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5938 45.1501L104.344 52.3303C104.968 52.9942 104.94 54.0429 104.281 54.6725L97.1611 61.4785",
    stroke: "white",
    strokeWidth: 6.6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.309 91.3923C179.48 99.0765 179.975 116.025 156.582 122.345",
    stroke: "white",
    strokeWidth: 6.6,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.151 129.338L150.791 124.166C150.016 123.686 149.772 122.667 150.246 121.888L155.378 113.453",
    stroke: "white",
    strokeWidth: 6.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon_report.b158c69ec5c488c8e95428dad8acc13d.svg";
export { ForwardRef as ReactComponent };